import React, { useState, useEffect } from 'react';
import {
  Snackbar,
  Alert,
  AlertTitle,
  Typography,
  Box,
  IconButton,
  Collapse
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon
} from '@mui/icons-material';

const PermissionWarning = () => {
  const [warning, setWarning] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    // Exposer la fonction globalement pour l'API
    window.showPermissionWarning = (errorData) => {
      setWarning(errorData);
      setExpanded(false);
    };

    // Nettoyage
    return () => {
      delete window.showPermissionWarning;
    };
  }, []);

  const handleClose = () => {
    setWarning(null);
    setExpanded(false);
  };

  if (!warning) return null;

  return (
    <Snackbar
      open={!!warning}
      autoHideDuration={8000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={handleClose} 
        severity="warning" 
        sx={{ 
          minWidth: 400,
          maxWidth: 600
        }}
      >
        <AlertTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Permission refusée
          <IconButton
            size="small"
            onClick={() => setExpanded(!expanded)}
            sx={{ ml: 1 }}
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </AlertTitle>
        
        <Typography variant="body2">
          {warning.detail}
        </Typography>

        <Collapse in={expanded}>
          <Box sx={{ mt: 2, p: 2, bgcolor: 'warning.light', borderRadius: 1 }}>
            <Typography variant="caption" display="block" gutterBottom>
              <strong>Détails techniques :</strong>
            </Typography>
            <Typography variant="caption" display="block">
              • Action : {warning.requiredPermission?.action}
            </Typography>
            <Typography variant="caption" display="block">
              • Module : {warning.requiredPermission?.module}
            </Typography>
            <Typography variant="caption" display="block">
              • Votre rôle : {warning.userRole}
            </Typography>
            <Typography variant="caption" display="block">
              • Votre équipe : {warning.teamName}
            </Typography>
            <Typography variant="caption" display="block" sx={{ mt: 1, fontWeight: 'bold' }}>
              💡 Solution : Demandez à un administrateur de vous donner les permissions de délégation pour cette action.
            </Typography>
          </Box>
        </Collapse>
      </Alert>
    </Snackbar>
  );
};

export default PermissionWarning;